var _style, _g, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg07BaseballSwing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:lean 1.6s ease-in-out infinite}\n@keyframes lean{0%,100%{transform:translateX(0) rotate(0)}25%{transform:translateX(-6px) rotate(-6deg)}45%{transform:translateX(8px) rotate(9deg)}}\n#batarm{transform-origin:168px 140px;animation:swing 1.6s ease-in-out infinite}\n@keyframes swing{0%,100%{transform:rotate(-40deg)}22%{transform:rotate(-78deg)}44%{transform:rotate(72deg)}70%{transform:rotate(50deg)}}\n#ball{offset-rotate:0deg;animation:fly 1.6s ease-in infinite}\n@keyframes fly{0%,40%{opacity:0;transform:translate(0,0)}44%{opacity:1;transform:translate(0,0)}100%{opacity:0;transform:translate(86px,-92px)}}\n#wh{opacity:0;animation:whoosh 1.6s ease-out infinite}\n@keyframes whoosh{0%,38%{opacity:0}50%{opacity:.9}70%,100%{opacity:0}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 62,
    width: 150,
    height: 144,
    rx: 50,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 122 Q92 104 106 122",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 122 Q150 104 164 122",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 152 q16 16 32 0",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "batarm"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 140,
    x2: 196,
    y2: 140,
    stroke: "#6FE3D0",
    strokeWidth: 14,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 133 h18 a8 8 0 0 1 8 7 a8 8 0 0 1 -8 7 h-18 z",
    fill: "#C98A4B",
    stroke: "#0E2A2E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 130 h26 a10 10 0 0 1 0 20 h-26 z",
    fill: "#E0A45F",
    stroke: "#0E2A2E",
    strokeWidth: 3
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wh",
    d: "M186 96 q26 14 30 40",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "ball",
    cx: 150,
    cy: 188,
    r: 11,
    fill: "#FFFFFF",
    stroke: "#0E2A2E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07BaseballSwing);
export default __webpack_public_path__ + "static/media/07-baseball-swing.5bdc7bcc5ea5d42044f523f4283b9727.svg";
export { ForwardRef as ReactComponent };